import { SimpleMutationOptions, useBaseMutation } from "../baseMutation";
import { MoveFolderFileByIdRequest, MoveFolderFileByIdResponse } from "@maven-rest/docs/FolderFile.dto";
import { FolderFileUrl } from "@maven-rest/docs/FolderFile.url";

export function useMoveFolderFileMutation(
  pathVariable: Pick<MoveFolderFileByIdRequest, "fileId">,
  options?: SimpleMutationOptions<MoveFolderFileByIdResponse, MoveFolderFileByIdRequest>
) {
  return useBaseMutation({
    fnOption: {
      url: FolderFileUrl.moveFolderFileById(pathVariable.fileId),
    },
    ...options,
  });
}
